import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { ResponsaveisTecnicosModel } from "./responsaveis-tecnicos.model";
import { ResponsaveisTecnicosService } from './responsaveis-tecnicos.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";

@Component({
  selector: 'app-responsaveis-tecnicos-form',
  templateUrl: './responsaveis-tecnicos-form.component.html'
})
export class ResponsaveisTecnicosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  responsavel: ResponsaveisTecnicosModel = new ResponsaveisTecnicosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private responsaveisTecnicosService: ResponsaveisTecnicosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]],
      cargo_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]],
      cargo_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]],
      cargo_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]],
      registro: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_responsavel_tecnico'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.visualizarResponsavelTecnico');
      } else {
        this.title = id ? this.func.traduzir('front.editarResponsavelTecnico') : this.func.traduzir('front.addResponsavelTecnico');
      }

      if (!id) {
        return;
      }

      this.responsaveisTecnicosService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarResponsavelTecnico') + ': ' + json.Payload[0].nome;
            } else {
              this.title = this.func.traduzir('front.visualizarResponsavelTecnico') + ': ' + json.Payload[0].nome;
            }

            this.responsavel = json.Payload[0];

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.responsaveisTecnicosService.editar(values, values.id);
    } else {
      result = this.responsaveisTecnicosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laudos-cd', 'responsaveis-tecnicos']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if (json.Message && json.Message.ErrorInput) {
          for (let i in json.Message.ErrorInput) {
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos-form.component.ts